// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__28kwR","col":"styles_col__3HOiK"};